import { render } from "./vacancyPDF.vue?vue&type=template&id=5cc6c5ce"
import script from "./vacancyPDF.vue?vue&type=script&lang=js"
export * from "./vacancyPDF.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__